<template>
    <div>
      <aiTongyong     type="1"> </aiTongyong> 
    </div>
  </template>
  <script>
  import aiTongyong from '../tongyong/aiTongyong.vue'
   
  export default {
  
    components: {
      aiTongyong: aiTongyong 
    },
  
    data() {
      return {
        // 获取用户列表参数
        
      };
    },
    props: [],
   
    watch: {
   
    },
    created() {
   
    },
    mounted() {
   
    }
  }
  </script>
